import React from 'react'
import { PlaybookSVG } from 'src/components/Icons/Basic'
import { FilterName, FilterParam } from '../FilterBar.types'
import { FilterDropdown } from './FilterDropdown'

const PLAYBOOK_TYPE_FILTER = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'trustero_built_in',
    label: 'Trustero built-in',
  },
  {
    value: 'custom',
    label: 'Custom',
  },
  {
    value: 'favorite',
    label: 'Favorites',
    divider: true,
  },
  {
    value: 'my_playbooks',
    label: 'My playbooks',
    divider: true,
  },
]

export const PlaybookTypeFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <FilterDropdown
        filterParam={FilterParam.PLAYBOOK_TYPE}
        filterName={FilterName.PLAYBOOK_TYPE}
        filterValues={PLAYBOOK_TYPE_FILTER}
        isNested={isNested}
        isSingleSelect={true}
        icon={<PlaybookSVG />}
      />
    )
  },
)
